// Centralized WhatsApp/Tintim link for all CTAs
export const WHATSAPP_LINK = "https://tintim.link/whatsapp/17a36622-1367-4e5e-a0a8-901d5181a4f3/94283f51-f5ca-4554-80be-e95b4a777d6a";

// Direct WhatsApp link (non-landing page)
export const WHATSAPP_DIRECT = "https://wa.me/5581993942858?text=vim%20pelo%20site%20de%20voc%C3%AAs%2C%20quero%20saber%20mais!";
